import React, {Component} from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';

import {geoUtils} from '../utils/geo-utils';

class NationalMapShapes extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    const widthDifferent = nextProps.width !== this.props.width;
    const heightDifferent = nextProps.height !== this.props.height;
    const dataDifferent = nextProps.data !== this.props.data;
    const dimXDiff = nextProps.dimX !== this.props.dimX;
    const dimYDiff = nextProps.dimY !== this.props.dimY;

    return widthDifferent || heightDifferent || dataDifferent || dimXDiff || dimYDiff;
  }

  render() {
    const paths = geoUtils.getAlbersUsaStatePaths(this.props.width, this.props.height);

    const bivarScale = geoUtils.createBivariateScale(this.props.data, this.props.dimX, this.props.dimY);

    const getValue = d => _.get(this.props.dict, [d.id], {});

    return (
      <g className="NationalMapShapes">
        {paths.map(d => {
          return (
            <path
              key={d.id}
              d={d.path}
              fill={bivarScale(getValue(d))}
            ></path>
          );
        })}
      </g>
    )
  }
}

NationalMapShapes.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  data: PropTypes.array,
  dimX: PropTypes.string,
  dimY: PropTypes.string,
};


export default NationalMapShapes


// WEBPACK FOOTER //
// ./src/charts/NationalMap/NationalMapShapes.js